import { useEffect } from "react";
import "./style.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import LoaderAHSF from "../../../../Components/LoaderAHSF";
import PopupAHSF from "../../../../Components/PopupAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import { GetDetailsBudget } from "../../../../Redux/Reducers/Submitter/DetailsBudget/iindex";

const DetailsBudget = (props) => {
    //   const state = useSelector((state) => {
    //     return {
    //       ApplicationInformation:
    //         state.ApplicationInformation.ApplicationInformation,
    //       BudgetDetails: state.BudgetDetails?.BudgetDetails,
    //       loadingBudgetDetails: state.BudgetDetails?.loadingBudgetDetails,
    //     };
    //   });
    const dispatch = useDispatch();
    const AppGuid = useParams();
    const DetailsBudgetReducers = useSelector((state) => state.DetailsBudgetReducers.DetailsBudget)
    // Function to add thousand separators to a number
    const numberWithCommas = (x) => {
        if (x == null || isNaN(x)) {
            return ""; // Return an empty string or handle the invalid input as needed
        }
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };


    useEffect(() => {
        dispatch(GetDetailsBudget({ applicationInformationId: localStorage.getItem("ApplicationInformationId")||props.applicationGuid }))
    }, [])

    

    const HTML = <>
        <div className="form-grid DetailsBudget">
            <InputAHSF
                fieldsName="EstimatedBudget"
                show={true}
                disabled={true}
                value={numberWithCommas(DetailsBudgetReducers?.estimatedBudget)}
            />
            <InputAHSF
                fieldsName="TotalAbdulHameedShomanContribution"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.totalAbdulHameedShomanContribution

                )}
            />
            <InputAHSF
                fieldsName="TotalBeneficiaryContribution"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.totalBeneficiaryContribution
                )}
            />
            <InputAHSF
                fieldsName="PercentageofBeneficiaryContribution"
                show={true}
                disabled={true}
                value={
                    Number(
                        DetailsBudgetReducers?.percentageofBeneficiaryContribution).toFixed(2) + "%"
                }
            />
            <InputAHSF
                fieldsName="ShomanContributionforEquipment"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.
                        shomanContributionforEquipment

                )}
            />
            <InputAHSF
                fieldsName="ShomanContributionforConferences"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.
                        shomanContributionforConferences
                )}
            />

            <InputAHSF
                fieldsName="PercentageofShomanContributionforConferences"
                show={true}
                disabled={true}
                value={
                    Number(
                        DetailsBudgetReducers?.
                            percentageofShomanContributionforConferences
                    ).toFixed(2) + "%"
                }
            />
            <InputAHSF
                fieldsName="TotalShomanContributionforMaterialsTools"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.
                        totalShomanContributionforMaterialsTools

                )}
            />
            <InputAHSF
                fieldsName="TotalShomanContributionforOtherExpenses"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.totalShomanContributionforOtherExpenses


                )}
            />
            <InputAHSF
                fieldsName="TotalShomanContributionforResearchAssistantsRewardsServiceAllowances"
                show={true}
                disabled={true}
                value={numberWithCommas(
                    DetailsBudgetReducers?.totalShomanContributionforResearchAssistantsRewardsServiceAllowances



                )}
            />

            {/* <LoaderAHSF show={state.loadingBudgetDetails} /> */}
        </div>
    </>

    return (
        <>
            {
                DetailsBudgetReducers?.totalShomanContributionforResearchAssistantsRewardsServiceAllowances != null ? HTML : <></>
            }
        </>
    );
};

export default DetailsBudget;
